"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBannerSize = exports.MWEB_MINWIDTH = exports.f2lh = exports.px2vw = exports.px2rem = exports.themeStyle = exports.Font = void 0;
var banner_1 = require("../../utils/playground/banner");
var Font;
(function (Font) {
    Font["Bold"] = "SFProText-Bold";
    Font["Heavy"] = "SFProText-Heavy";
    Font["Light"] = "SFProText-Light";
    Font["Medium"] = "SFProText-Medium";
    Font["Regular"] = "SFProText-Regular";
    Font["Semibold"] = "SFProText-Semibold";
})(Font = exports.Font || (exports.Font = {}));
exports.themeStyle = {
    red: "#E62222",
    black: "#1A1A1A",
    gray: "#C7C7CC",
    text1: "#333",
    text2: "#666",
    text3: "#999",
    text4: "#CCC",
    divider1: "#E0E0E0",
    divider2: "#ECECEC",
    background: "#F5F5F5",
    link: "#4a90e2"
};
exports.px2rem = function (pxValue, defaultValue) {
    if (defaultValue === void 0) { defaultValue = "initial"; }
    if (typeof pxValue !== "undefined") {
        return Number((pxValue / 16).toFixed(4)) + "rem";
    }
    else {
        return defaultValue;
    }
};
exports.px2vw = function (pxValue) {
    return Number(((pxValue * 100) / 375).toFixed(4)) + "vw";
};
exports.f2lh = function (fontSize, defaultValue) {
    if (defaultValue === void 0) { defaultValue = "initial"; }
    var lineHeightPX;
    switch (fontSize) {
        case 24:
            lineHeightPX = 28;
            break;
        case 18:
            lineHeightPX = 26;
            break;
        case 17:
            lineHeightPX = 24;
            break;
        case 16:
            lineHeightPX = 22;
            break;
        case 15:
            lineHeightPX = 20;
            break;
        case 13:
            lineHeightPX = 18;
            break;
        case 12:
            lineHeightPX = 16;
            break;
        default:
    }
    if (typeof lineHeightPX !== "undefined") {
        return Number((lineHeightPX / 16).toFixed(4)) + "rem";
    }
    else {
        return defaultValue;
    }
};
exports.MWEB_MINWIDTH = 750;
exports.formatBannerSize = function (_a) {
    var width = _a.width, height = _a.height;
    var bannerWidth = banner_1.formatAspect(width || "");
    var bannerHeight = banner_1.formatAspect(height || "");
    var aspectRatio = bannerWidth ? (+bannerHeight / bannerWidth).toFixed(3) : 0;
    return {
        width: Math.max(bannerWidth, exports.MWEB_MINWIDTH),
        height: aspectRatio ? +aspectRatio * 100 + "vw" : "auto"
    };
};
